import { removeUser } from "./localStorage";

export const signOut = async (): Promise<void> => {
  await import("aws-amplify/auth").then(({ signOut: amplifySignOut }) => amplifySignOut());
  removeUser();
};
